// extracted by mini-css-extract-plugin
export default {"root":"_2fH0Nn2t","contentContainer":"_2PfPAPlN","content":"_1xVPfZvO","header":"S1itY2Af","logo":"_1k1vEvZd","pane":"_3xrdRBfa"};